import { render, staticRenderFns } from "./DiagPartiallySupported.vue?vue&type=template&id=db222ef4&"
import script from "./DiagPartiallySupported.vue?vue&type=script&lang=js&"
export * from "./DiagPartiallySupported.vue?vue&type=script&lang=js&"
import style0 from "./DiagPartiallySupported.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports